import { guidedTourReducer, GuidedTourReducerState } from './guidedTourReducer';
import { ttsSettingsReducer, TTSSettingsReducerState } from './ttsSettingsReducer';
import { combineReducers } from '@reduxjs/toolkit';
import {captionsEnabledReducer, CaptionsEnabledReducerState} from './captionsEnabledReducer';

export type PreferencesState = {
  captionsEnabled: CaptionsEnabledReducerState;
  guidedTour: GuidedTourReducerState;
  ttsSettings: TTSSettingsReducerState;
};

export const preferencesReducer = combineReducers({
  captionsEnabled: captionsEnabledReducer,
  guidedTour: guidedTourReducer,
  ttsSettings: ttsSettingsReducer,
});
